import CustomLayout from '../../components/CustomLayout';
import ForgotPassword from '../../components/auth/ForgotPassword';

const ForgotPasswordPage = (props) => {
    return (
        <CustomLayout 
            title="forgot password - fablement"
        >
            <ForgotPassword />
        </CustomLayout>
    );
}

export default ForgotPasswordPage;